module.exports = __webpack_public_path__ + "img/menu0.9fecd596.png";